import { SafePromise } from '@benzinga/safe-await';

import { RestfulClient } from '@benzinga/session';
import { Session, StockSymbol } from '@benzinga/session';
import { QuotesEnvironment } from '../environment';
import { PeersResponse } from '../entities';

export class QuotesPeersRestful extends RestfulClient {
  constructor(session: Session) {
    super(session.getEnvironment(QuotesEnvironment).nextApiUrl, session, {
      authorization: true,
      'x-device-key': true,
    });
  }

  getPeers = async (symbol: StockSymbol): SafePromise<PeersResponse> => {
    const url = this.URL(`quote/${symbol}/peers`);

    return this.get(url, {
      allowsAnonymousAuth: true,
      credentials: 'same-origin',
    });
  };
}
